import React, { useEffect, useState } from 'react';

const AttachmentPreview = () => {
    const [base64Data, setBase64Data] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchAttachment() {
            try {
                const params = new URLSearchParams(window.location.search);
                const partId = params.get('partId');

                if (!partId) {
                    throw new Error('Missing partId in URL parameters');
                }

                const response = await fetch(`/api/attachments/${partId}`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch attachment: ${response.statusText}`);
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setBase64Data(reader.result);
                    setLoading(false);
                };
                reader.onerror = () => {
                    throw new Error('Error reading attachment data');
                };
                reader.readAsDataURL(blob);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        }

        fetchAttachment();
    }, []);

    if (loading) {
        return <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>;
    }

    if (error) {
        return <div style={{ textAlign: 'center', color: 'red', marginTop: '20px' }}>{error}</div>;
    }

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            margin: 0,
            padding: 0,
            overflow: 'hidden',
            zIndex: 9999,
            backgroundColor: '#fff',
        }}>
            <iframe
                src={base64Data + "#view=FitH&toolbar=0"}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                }}
                title="PDF Viewer"
            />
        </div>
    );
};

export default AttachmentPreview;
